<template>
  <b-row>
    <b-col cols="12" class="mt-3">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left">
            <span class="mb-0 h3 ml-2">取貨管理</span>
          </div>
        </template>
        <b-navbar class="mt-2">
          <b-navbar-nav>
            <b-form inline @submit.prevent>
              <label class="mr-sm-2" for="inline-form-input-uqidInpu">訂單編號：</label>
              <b-form-input
                id="inline-form-input-uqidInput"
                v-model="uqidInput"
                class="mr-2"
              ></b-form-input>
            </b-form>
            <b-form inline @submit.prevent>
              <label class="mr-sm-2" for="inline-form-input-receiverInput">取貨人：</label>
              <b-form-input
                id="inline-form-input-receiverInput"
                v-model="receiverInput"
                class="mr-2"
              ></b-form-input>
            </b-form>
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item class="mr-1">
              <b-button
                :disabled="!selectedArray.length"
                variant="primary"
                size="sm"
                @click="onClickSetComplete"
              >取貨完成</b-button>
            </b-nav-item>
            <b-nav-form>
              <b-form-select v-model="each" size="sm" class="float-right">
                <b-form-select-option v-for="n in [10, 20, 30, 50]" :value="n" :key="n">每頁顯示筆數: {{ n }}</b-form-select-option>
              </b-form-select>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-table
          id="user-table"
          bordered
          show-empty
          empty-text="未搜尋到訂單"
          hover
          :items="items"
          :fields="fields"
          :busy="Boolean(isBusy)"
          responsive
          class="mt-2"
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:head(checkbox)>
            <b-form-checkbox id="checkbox-all" @change="onClickSelectAll" :indeterminate="isParticalSelected">選取</b-form-checkbox>
          </template>
          <template v-slot:cell(checkbox)="data">
            <b-form-checkbox
              :id="`checkbox-${data.item.id}`"
              v-model="selectedArray"
              :value="data.item.id"
            >
            </b-form-checkbox>
          </template>
          <template v-slot:cell(ops)="data">
            <b-link :to="`/admin/deliver/${data.item.id}/view`">查看訂單</b-link>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="each"
          aria-controls="user-table"
          class="float-right"
        ></b-pagination>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import moment from 'moment'
import QueryString from 'querystring'
import { Payments, DeliverStates } from '../../library/Var.js'
export default {
  data () {
    return {
      currentPage: 1,
      rows: 0,
      each: 10,
      uqidInput: '',
      receiverInput: '',
      items: [],
      isBusy: false,
      selectedArray: []
    }
  },
  computed: {
    fields () {
      return [
        { key: 'checkbox', label: '選取', tdClass: 'text-center' },
        { key: 'uqid', label: '訂單編號', tdClass: 'text-center' },
        { key: 'time', label: '下單時間', tdClass: 'text-center' },
        { key: 'orderer', label: '購買人姓名', tdClass: 'text-center' },
        { key: 'receiver', label: '取貨人姓名', tdClass: 'text-center' },
        { key: 'total', label: '訂單金額', tdClass: 'text-center' },
        { key: 'pay', label: '支付方式', tdClass: 'text-center' },
        { key: 'state', label: '訂單狀態', tdClass: 'text-center' },
        { key: 'ops', label: '操作', tdClass: 'text-center' }
      ]
    },
    query () {
      const obj = {
        page: this.currentPage,
        each: this.each,
        state: 'ready'
      }
      if (this.uqidInput) {
        obj.uqid = this.uqidInput
      }
      if (this.receiverInput) {
        obj.receiver = this.receiverInput
      }
      const str = QueryString.stringify(obj)
      return `?${str}`
    },
    isParticalSelected () {
      return this.items.length && this.selectedArray.length && this.items.length !== this.selectedArray.length
    }
  },
  methods: {
    start () {
      if (this.isBusy) {
        clearTimeout(this.isBusy)
      }
      this.isBusy = setTimeout(async () => {
        try {
          const { data } = await this.$api.getDel(this.query)
          this.items = data.map(item => {
            const payment = Payments.find(item => item.value === item.pay_type)
            return {
              id: item.id,
              uqid: item.uqid,
              time: moment(item.time).format('YYYY/MM/DD HH:mm:ss'),
              orderer: item.orderer,
              receiver: item.receiver,
              total: item.total,
              pay: payment ? payment.name : '無',
              state: DeliverStates[item.state] || '異常'
            }
          })
        } catch (err) {
          console.log(err)
        } finally {
          this.isBusy = false
        }
      }, 1000)
    },
    async onClickSetComplete () {
      if (this.isBusy) return
      this.isBusy = true
      const wait = this.selectedArray.map(id => this.$api.putDel(id, 'complete'))
      try {
        await Promise.all(wait)
        this.$bvToast.toast('資料已更新。', {
          variant: 'success',
          title: '操作成功'
        })
        this.isBusy = false
        await this.start()
        this.selectedArray = []
      } catch (err) {
        this.$bvToast.toast('連線失敗，資料未成功改變狀態。', {
          variant: 'danger',
          title: '發生錯誤'
        })
      }
    },
    onClickSelectAll (val) {
      let array = []
      if (val) {
        array = this.items.map(item => item.id)
      }
      this.selectedArray = array
    }
  },
  mounted () {
    this.start()
  },
  watch: {
    query () {
      this.start()
    }
  }
}
</script>
